module.exports = __webpack_public_path__ + "static/media/processbanner.bf94d98a.png";